import React, { useState } from 'react';
import { Tag, Tooltip } from 'antd';
import { sanitize } from 'dompurify';

import { AttributeTag } from 'components/TagsDiagram/AttributeTag';
import Button from 'components/AntD/Button';

const MAX_STRENGTHS_TO_DISPLAY = 5;

interface MySearchlightStrengthsProps {
  strengths: AttributeTag[];
}

const ThumbsUp = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.68392 4.0257L8.86728 2.13065C8.94104 1.36895 9.65168 0.852282 10.3702 1.03794C11.4514 1.3173 12.21 2.32131 12.21 3.47313V5.90099C12.21 6.44099 12.21 6.71099 12.3272 6.90952C12.3935 7.02183 12.4849 7.11619 12.5935 7.18474C12.7856 7.30591 13.0469 7.30591 13.5694 7.30591H13.8864C15.2486 7.30591 15.9298 7.30591 16.3491 7.61832C16.6629 7.85192 16.8842 8.19496 16.9722 8.58408C17.0899 9.10432 16.8279 9.75408 16.304 11.0537L16.0428 11.7015C15.8919 12.0758 15.8302 12.4818 15.8627 12.8858C16.0481 15.1845 14.2246 17.1219 11.9961 16.994L3.65654 16.5152C2.74582 16.4629 2.29046 16.4367 1.87885 16.0726C1.46725 15.7085 1.38981 15.3335 1.23492 14.5838C1.1029 13.9446 1 13.161 1 12.271C1 11.284 1.12657 10.4278 1.27906 9.7544C1.50526 8.7556 2.45936 8.21856 3.44427 8.34576C6.05509 8.68304 8.42216 6.73143 8.68392 4.0257Z"
      stroke="#424250"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.00011 8.60004L4.89052 8.96532C4.18094 11.3306 4.21921 13.8573 5.00011 16.2"
      stroke="#424250"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MySearchlightStrengths = ({ strengths = [] }: MySearchlightStrengthsProps) => {
  const [showAll, setShowAll] = useState(false);

  return (
    <div>
      <div className="tw-flex tw-flex-row tw-flex-wrap tw-gap-4">
        {strengths.slice(0, showAll ? strengths.length : MAX_STRENGTHS_TO_DISPLAY).map(s => {
          const { label, references = [], subtitle = '' } = s;
          return (
            <Tag
              key={`strength_${label}`}
              className="tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-gray-700 tw-capitalize tw-bg-transparent tw-rounded-full tw-border-gray"
            >
              <Tooltip title={<span dangerouslySetInnerHTML={{ __html: sanitize(subtitle) }} />}>
                <div className="tw-flex tw-flex-row tw-justify-between tw-gap-5 tw-items-center">
                  <span className="tw-text-ellipsis">{label}</span>
                  <div className="tw-flex tw-flex-row tw-gap-2 tw-items-center">
                    <span>{references.length}</span>
                    <ThumbsUp />
                  </div>
                </div>
              </Tooltip>
            </Tag>
          );
        })}
        {strengths.length > MAX_STRENGTHS_TO_DISPLAY && (
          <Button
            className="tw-font-medium tw-my-auto"
            variant="text"
            color="primary"
            onClick={() => setShowAll(!showAll)}
            size="small"
          >
            {showAll ? '- Collapse' : '+ See All'}
          </Button>
        )}
      </div>
    </div>
  );
};

export default MySearchlightStrengths;
